var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1940_25330)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 14,
    fill: "#FEF0F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1940_25330)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1940_25330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8 15.6863 10.6863 13 14 13H51C54.3137 13 57 15.6863 57 19V78H8V19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 17,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 19,
    width: 11,
    height: 2,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 41,
    height: 9,
    fill: "#FEE7EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 41,
    width: 12,
    height: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 51,
    width: 12,
    height: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2,
    y: 61.2,
    width: 11.6,
    height: 7.6,
    fill: "#FEF0F2",
    stroke: "#FA8596",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 41,
    width: 13,
    height: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 51.2,
    width: 12.6,
    height: 7.6,
    fill: "#FEF7E1",
    stroke: "#FCE08D",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 61,
    width: 13,
    height: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 41.2,
    width: 11.6,
    height: 7.6,
    fill: "#E1F3FF",
    stroke: "#81CFFE",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 51,
    width: 12,
    height: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 61,
    width: 12,
    height: 8,
    fill: "#F5F5F5"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 64.4,
    height: 64.4,
    rx: 13.7,
    stroke: "#FCB6C0",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1940_25330",
    x: -2,
    y: 7,
    width: 69,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1940_25330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1940_25330",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_25330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1940_25330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8 15.6863 10.6863 13 14 13H51C54.3137 13 57 15.6863 57 19V78H8V19Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTrips);
export default __webpack_public_path__ + "static/media/live-trips.45ac9dbe9f1a6a58407507915e177f2d.svg";
export { ForwardRef as ReactComponent };